import { memo } from 'react';

import { Trans } from 'react-i18next';

import { formatTimeOnly } from '@/util/dateUtils';

interface TriggerLabelProps {
  created: string;
}

/**
 * TriggerLabel component displays a system label indicating that
 * a conversation was triggered by Autostart
 */
export const TriggerLabel = memo(({ created }: TriggerLabelProps) => {
  const time = formatTimeOnly(created);

  return (
    <div className="mt-4 flex justify-center gap-1 px-4 py-2 [.event+&]:mt-0">
      <span className="text-sm leading-5 font-normal text-muted-foreground">
        <Trans
          i18nKey="conversation.triggered_by_autostart"
          values={{ 0: time }}
          components={{
            strong: <span className="text-sm leading-5 font-semibold text-muted-foreground" />,
          }}
        />
      </span>
    </div>
  );
});

TriggerLabel.displayName = 'TriggerLabel';
